// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SplitSvg from '@rsuite/icon-font/lib/flow/Split';
var Split = createSvgIcon({
  as: SplitSvg,
  ariaLabel: 'split',
  category: 'flow',
  displayName: 'Split'
});
export default Split;